import { MessageCircle } from "lucide-react";
import { CONVENIOS, CONVENIO_LOGO_BASE, waLink } from "../../lib/constants";
import useReveal from "../../hooks/useReveal";

export default function Convenios() {
  const { ref, isVisible } = useReveal();

  return (
    <section
      id="convenios"
      ref={ref}
      className={`py-24 md:py-32 bg-[#EEF4FF] reveal-section ${isVisible ? "is-visible" : ""}`}
      data-testid="convenios-section"
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center bg-[#0D47A1]/10 text-[#0D47A1] rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
            Convênios Aceitos
          </div>
          <h2 className="font-poppins font-bold text-3xl sm:text-4xl text-[#212121] mb-4 leading-tight">
            Atendemos Seu Plano de Saúde
          </h2>
          <p className="text-base text-[#212121]/65">
            A maioria dos convênios cobre a avaliação e o tratamento de derrame pleural.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mb-6">
          {CONVENIOS.map((c) => (
            <div
              key={c.slug}
              data-testid={`insurance-logo-${c.slug}`}
              className="bg-white border border-gray-100 rounded-xl px-5 py-4 flex flex-col items-center justify-center gap-2 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
              style={{ minHeight: "112px" }}
            >
              <div className="w-full h-10 flex items-center justify-center">
                <img
                  alt={`${c.name} - convênio aceito por Dr. Mateus Marques cirurgião torácico em Feira de Santana`}
                  className="h-10 w-auto max-w-full object-contain"
                  loading="lazy"
                  src={`${CONVENIO_LOGO_BASE}/${c.slug}.png`}
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              </div>
              <span className="font-poppins font-semibold text-xs text-[#212121]/75 text-center leading-tight">
                {c.name}
              </span>
            </div>
          ))}
        </div>

        <div className="bg-white border border-[#0D47A1]/20 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto text-center shadow-sm">
          <p className="text-[#212121]/75 text-base mb-4">
            Caso seu convênio não esteja na lista, entre em contato com a nossa equipe para verificação.
            A maioria dos planos tem cobertura para a avaliação e procedimentos.
          </p>
          <a
            href={waLink("Olá, vim do site e gostaria de saber se dr. Mateus atende o meu convênio")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="convenios-cta-button"
            className="inline-flex items-center gap-2 bg-[#0D47A1] text-white font-poppins font-semibold px-8 py-3.5 rounded-full hover:bg-[#00897B] transition-colors duration-200"
          >
            <MessageCircle size={18} />
            Consultar Convênios
          </a>
        </div>
      </div>
    </section>
  );
}
